import * as $ from 'jquery';
import 'bootstrap';

/**
 * @module c051 siteHeaderSearch
 * search form logic for main search bar in top nav
 *
 * @author Maneesh Pokhriyal <maneesh.pokhriyal@mirumagency.com>
 */
export class siteHeaderSearch {
	private $form = $("#searchpagebar-form-header");
	private $mobileForm = $("#searchpagebar-form-header-mobile");
	private searchBar = $('#search-searchbar');

	formAction = this.$form.attr('action');
	lang = this.$form.attr('lang');

	formActionMobile = this.$mobileForm.attr('action');
	/**
	 * @function initSearchForm
	 */
	initSearchForm(): void {
		let _self = this;
		_self.$form.submit(function () {
			var text = "" ;
			var desktopText = $("#search-input-header").val() ;
			var mobileText = $("#mobile-search").val() ;

			if ( mobileText) {
				text = mobileText ;
			} else {
				text = desktopText ;
			}

			var data = localStorage['mas-search'];
			var obj =  {};

			if (text != '') {
				obj = {text};
				var parsed  = JSON.stringify(obj);
				let arr:Array<any> = [] ;

				if (data == null) {
					arr[0] = parsed ;
					localStorage.setItem("mas-search", JSON.stringify(arr));

				} else {
					var dataList = JSON.parse(localStorage['mas-search']);
					$.each(dataList, function(i:number, item:any) {
						arr[i] = dataList[i] ;
					});
					arr[arr.length] = parsed ;
					localStorage['mas-search'] = JSON.stringify(arr);
				}
			}

			// search text
			var url = _self.formAction + "?" + "q=" ;
			_self.$form.attr('action', url);
		});
		_self.$mobileForm.submit(function () {
			var text = "" ;
			var mobileText = $("#mobile-search").val() ;
			var data = localStorage['mas-search'];
			var obj =  {};
			if (mobileText != '') {
				obj = {text};
				var parsed  = JSON.stringify(obj);
				let arr:Array<any> = [] ;

				if (data == null) {
					arr[0] = parsed ;
					localStorage.setItem("mas-search", JSON.stringify(arr));

				} else {
					var dataList = JSON.parse(localStorage['mas-search']);
					$.each(dataList, function(i:number, item:any) {
						arr[i] = dataList[i] ;
					});
					arr[arr.length] = parsed ;
					localStorage['mas-search'] = JSON.stringify(arr);
				}
			}

			// search text
			var url = _self.formActionMobile + "?" + "q=" ;
			_self.$mobileForm.attr('action', url);
		});
	}

	/**
	 * @function icon
	 * trigger form submit when click search icon
	 */
	initSubmit(): void {
		let _self = this;
		let $searchIcon = $('#top-search-icon');

		$searchIcon.click(function () {
			_self.$mobileForm.submit();
		});
	}

	/**
	 * @function mobileSearch
	 * apply placeholder to mobile saerch bar if mobile search exists
	 */
	mobileSearch():void {

		let $searchInputHeader = $("#search-input-header");
		let $searchMobile = $("#mobile-search");

		if ($searchInputHeader && $searchMobile) {
			$searchMobile.attr({
				'placeholder' : $searchInputHeader.attr('placeholder')
			});
		}
	}
}

let scope:Element = document.querySelector('#searchpagebar-form-header');

if (scope){
	try {
		let siteheadersearch = new siteHeaderSearch();
		siteheadersearch.initSearchForm();
		siteheadersearch.initSubmit();
		siteheadersearch.mobileSearch();
	} catch(e) {console.error(e);}
}
